import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Paper, Stack, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import AdminActionGroup from '../components/AdminActionGroup';

export const INVOICE_CREATION_STEPS = ['Programme', 'Client', 'Learner', 'Charge', 'Review'];

const programmes = [
  { value: 'tutoring', label: 'One-to-one tutoring', description: 'Create an invoice for a monthly package, sessions or a trial lesson.' },
  { value: 'matric_rewrite', label: 'Matric Rewrite', description: 'Open Matric intake applications to manage the invoice linked to a learner and intake.' },
  { value: 'math', label: 'Maths & Science', description: 'Programme invoice creation is not available yet.', disabled: true },
  { value: 'homeschooling', label: 'Homeschooling', description: 'Programme invoice creation is not available yet.', disabled: true },
];

export default function BillingProgrammeSelection({ onContinue }) {
  const navigate = useNavigate();
  const [programme, setProgramme] = useState('');

  return <DashboardLayout><Stack spacing={2.5} className="billing-module billing-wizard">
    <AdminActionGroup><Button onClick={() => navigate('/admin/billing')}>Invoice register</Button></AdminActionGroup>
    <Paper className="billing-wizard-head"><Stepper activeStep={0} alternativeLabel>
      {INVOICE_CREATION_STEPS.map((label) => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
    </Stepper></Paper>
    <Card><CardContent className="billing-step-card"><Stack spacing={2}>
      <Typography variant="h6">Choose a programme</Typography>
      <Typography color="text.secondary">Select the programme this invoice is for.</Typography>
      <Box className="billing-choice-grid" aria-label="Invoice programme">
        {programmes.map((item) => <button type="button" key={item.value}
          className={`billing-choice ${programme === item.value ? 'selected' : ''}`}
          aria-pressed={programme === item.value} disabled={item.disabled}
          onClick={() => setProgramme(item.value)}>
          <strong>{item.label}</strong><span>{item.description}</span>
        </button>)}
      </Box>
      {programme === 'matric_rewrite' && <Typography color="text.secondary">Continue to Matric Intake Operations, find the learner, and choose Invoice &amp; payment to email their registration invoice or full balance.</Typography>}
    </Stack></CardContent></Card>
    <AdminActionGroup align="between"><span /><Button variant="contained" color="success"
      disabled={!programme} onClick={() => programme === 'matric_rewrite' ? navigate('/admin/matric-intakes') : onContinue(programme)}>
      {programme === 'matric_rewrite' ? 'Continue to Matric applications' : 'Save & continue'}
    </Button></AdminActionGroup>
  </Stack></DashboardLayout>;
}
